/**
 * Feature flags — 미완성/단계적 출시 기능 토글
 *
 * 빅테크 표준 패턴 (trunk-based development):
 *   · 코드는 main 에 머지하지만 일반 사용자에겐 hidden
 *   · admin 계정은 prod 에서도 dogfooding 가능
 *   · staging 빌드는 NEXT_PUBLIC_* env 로 항상 on
 *
 * 사용법:
 *   import { isCommunityEnabled } from "@/lib/feature-flags";
 *   const enabled = isCommunityEnabled(auth?.email, auth?.isAdmin);
 *
 * 출시 절차:
 *   1) staging 검증 통과
 *   2) admin dogfood prod 에서 수일~수주
 *   3) 만족 → 본섭 .env 에 NEXT_PUBLIC_<FLAG>=true → pm2 restart ticker-frontend
 *   4) 안정화 후 flag 제거 (이 helper 에서도 함수 삭제)
 */

/** NEXT_PUBLIC_* 는 빌드타임에 인라인됨 → staging build 와 prod build 가 다른 값.
 *  Next.js 는 동적 인덱싱 (process.env[name]) 을 정적 치환 못 함 → 명시적 분기 필요. */
function envCommunity(): boolean {
  return process.env.NEXT_PUBLIC_COMMUNITY_ENABLED === "true";
}

/**
 * 커뮤니티 페이지 노출 여부.
 * - staging build: NEXT_PUBLIC_COMMUNITY_ENABLED=true → 항상 on
 * - prod build: env 미설정 → admin only (dogfooding)
 */
export function isCommunityEnabled(
  _email?: string | null,
  isAdmin?: boolean | null,
): boolean {
  if (envCommunity()) return true;
  if (isAdmin) return true;
  return false;
}
